exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lagjw{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}.lagjw:hover{opacity:.7}._1u6OI{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._3KfuE{position:absolute;z-index:10000;top:10px;left:10px;overflow:scroll;width:400px;height:250px;border-radius:3px;background-color:rgba(0,0,0,.95)}._3KfuE .n8Ngk{position:absolute;top:10px;right:5px;cursor:pointer;color:#fff}._3KfuE .n8Ngk:hover{opacity:.8}._3KfuE ._1ScCy{font-size:8px;line-height:8px;margin:5px;padding:5px;color:#fff}._3KfuE ._1ScCy ._1XUl3{color:green}._3KfuE ._1ScCy ._1ja4x{color:#ff8c00}._3KfuE ._1ScCy ._2z7Yx{color:#00f}._3KfuE ._1ScCy ._1x3Qg{color:#f0f}._3KfuE ._1ScCy .pnHeN{color:#fff}", ""]);

// exports
exports.locals = {
	"controlButton": "lagjw",
	"hidden": "_1u6OI",
	"debugPanel": "_3KfuE",
	"closeButton": "n8Ngk",
	"infoContainer": "_1ScCy",
	"string": "_1XUl3",
	"number": "_1ja4x",
	"boolean": "_2z7Yx",
	"null": "_1x3Qg",
	"key": "pnHeN"
};